import { useTranslation } from 'react-i18next';
import type { AppLanguage } from '../../lib/i18n/config';

const LANGUAGE_OPTIONS: Array<{ code: AppLanguage; labelKey: 'language_vi' | 'language_en' }> = [
  { code: 'vi', labelKey: 'language_vi' },
  { code: 'en', labelKey: 'language_en' },
];

interface LanguageSwitcherProps {
  readonly className?: string;
  readonly variant?: 'default' | 'auth';
}

export function LanguageSwitcher({ className = '', variant = 'default' }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation('common');
  const resolved = i18n.resolvedLanguage ?? i18n.language;
  const current = (resolved?.startsWith('en') ? 'en' : 'vi') as AppLanguage;

  const isAuth = variant === 'auth';
  const baseClass = isAuth
    ? 'rounded-lg border border-white/30 bg-white/10 text-white text-sm px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-white/40 [color-scheme:dark]'
    : 'rounded-lg border border-border bg-background text-foreground text-sm px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-ring';
  const optionClass = isAuth ? 'bg-violet-950 text-white' : undefined;

  return (
    <label className={`inline-flex items-center gap-2 ${className}`}>
      <span className="sr-only">{t('language')}</span>
      <select
        value={current}
        onChange={event => {
          const next = event.target.value as AppLanguage;
          void i18n.changeLanguage(next);
        }}
        className={baseClass}
        aria-label={t('language')}
      >
        {LANGUAGE_OPTIONS.map(({ code, labelKey }) => (
          <option key={code} value={code} className={optionClass}>
            {t(labelKey)}
          </option>
        ))}
      </select>
    </label>
  );
}
